(function () {
  'use strict';

  const root = document.querySelector('.manuals-hub');
  if (!root) return;

  const dataEl = document.getElementById('manuals-data');
  const grid = root.querySelector('#manuals-grid');
  const searchInput = root.querySelector('#manuals-search');
  const searchClear = root.querySelector('.manuals-hub__search-clear');
  const chips = root.querySelectorAll('.manuals-hub__chip');
  const countEl = root.querySelector('[data-count]');
  const emptyEl = root.querySelector('.manuals-hub__empty');
  const resetBtn = root.querySelector('.manuals-hub__reset');
  const sortSelect = root.querySelector('#manuals-sort');

  let manuals = [];
  try {
    manuals = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[ManualsHub] Invalid data JSON', e);
    return;
  }

  const defaultSort = (a, b) => {
    const aHasImage = a.image && !a.image.includes('lifepro-placeholder') ? 0 : 1;
    const bHasImage = b.image && !b.image.includes('lifepro-placeholder') ? 0 : 1;
    if (aHasImage !== bHasImage) return aHasImage - bHasImage;
    return a.name.localeCompare(b.name);
  };
  manuals.sort(defaultSort);

  const fuse = new Fuse(manuals, {
    keys: [
      { name: 'name', weight: 0.5 },
      { name: 'model', weight: 0.35 },
      { name: 'keywords', weight: 0.15 }
    ],
    threshold: 0.35,
    ignoreLocation: true,
    minMatchCharLength: 2
  });

  let activeCategory = 'All';
  let activeQuery = '';
  let activeSort = 'default';

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

  function cardHTML(m) {
    return `
      <article class="manual-card" data-id="${m.id}">
        <div class="manual-card__media">
          <span class="manual-card__badge" aria-label="PDF Manual">
            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13z"/>
            </svg>
            PDF
          </span>
          <img src="${escapeHtml(m.image)}" alt="${escapeHtml(m.imageAlt)}"
               loading="lazy" decoding="async" width="400" height="400">
        </div>
        <div class="manual-card__body">
          <h3 class="manual-card__name">${escapeHtml(m.name)}</h3>
          ${m.model ? `<p class="manual-card__model">${escapeHtml(m.model)}</p>` : '<p class="manual-card__model">&nbsp;</p>'}
          <div class="manual-card__ctas">
            <a class="btn btn--primary"
               href="${escapeHtml(m.pdf)}"
               target="_blank" rel="noopener"
               data-track="manual_download"
               data-model="${escapeHtml(m.model)}"
               download>
              Download Manual
            </a>
            ${m.shopUrl ? `<a class="btn btn--secondary" href="${escapeHtml(m.shopUrl)}" data-track="shop_product" data-model="${escapeHtml(m.model)}">Shop Product</a>` : ''}
          </div>
        </div>
      </article>
    `;
  }

  function filterResults() {
    let results = manuals.slice();
    if (activeQuery.length >= 2) {
      results = fuse.search(activeQuery).map(r => r.item);
    }
    if (activeCategory !== 'All') {
      results = results.filter(m => m.category === activeCategory);
    }
    if (activeSort === 'za') {
      results.sort((a, b) => b.name.localeCompare(a.name));
    } else if (activeQuery.length < 2) {
      results.sort(defaultSort);
    }
    return results;
  }

  function render() {
    const results = filterResults();
    countEl.textContent = `${results.length} manual${results.length === 1 ? '' : 's'}`;
    emptyEl.hidden = results.length > 0;
    grid.innerHTML = results.map(cardHTML).join('');
  }

  let searchTimer;
  searchInput.addEventListener('input', (e) => {
    activeQuery = e.target.value.trim();
    searchClear.hidden = activeQuery.length === 0;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(render, 120);
  });

  searchClear.addEventListener('click', () => {
    searchInput.value = '';
    activeQuery = '';
    searchClear.hidden = true;
    render();
    searchInput.focus();
  });

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chips.forEach(c => {
        c.classList.remove('is-active');
        c.setAttribute('aria-selected', 'false');
      });
      chip.classList.add('is-active');
      chip.setAttribute('aria-selected', 'true');
      activeCategory = chip.dataset.category;
      render();
    });
  });

  sortSelect?.addEventListener('change', (e) => {
    activeSort = e.target.value;
    render();
  });

  resetBtn?.addEventListener('click', () => {
    searchInput.value = '';
    activeQuery = '';
    searchClear.hidden = true;
    chips[0].click();
  });

  grid.addEventListener('click', (e) => {
    const a = e.target.closest('[data-track]');
    if (!a) return;
    const event = a.dataset.track;
    const model = a.dataset.model;
    if (window.dataLayer) {
      window.dataLayer.push({
        event: event,
        manual_model: model,
        category: activeCategory,
        search_query: activeQuery || null
      });
    }
  });

  render();
})();